<!--
 * @Author: ymk
 * @Date: 2020-07-27 15:53:51
 * @LastEditors: ymk
 * @LastEditTime: 2020-07-28 18:50:19
 * @FilePath: \car-demo\src\components\SchoolItem.vue
-->
<template>
	<div class="flex school-item" v-if="storeDetail">
		<img
			v-if="storeDetail"
			class="pictrue"
			:style="{ width, height }"
			:src="storeDetail.store_banner"
			alt="..."
		/>

		<ul>
			<li class="flex a-center">
				<span class="name">{{storeDetail.store_name}}</span>
				<img v-show="storeDetail.is_own_shop == 1"
					src="../assets/images/vip-icon.png"
					alt="..."
					style="width: 14px; height: 14px"
				/>
			</li>
			<li class="address">
				<template v-if="storeDetail.city_text.length > 1">{{storeDetail.city_text}}</template> {{storeDetail.district_text}}
			</li>
			<li class="price flex a-center j-between" v-if="Object.keys(this.storeDetail.class).length > 0">
				￥{{storeDetail.class.shop_price}} {{storeDetail.class.cat_id1_name}} {{storeDetail.class.title}}

			</li>
			<li class="price flex a-center j-between" v-if="Object.keys(this.storeDetail.class).length > 0 && storeDetail.class.class_type == 1">
				<span class="text-red" v-if="storeDetail.class.class_type == 1">拼团价:￥{{storeDetail.class.group_price}}</span>
			</li>
			<li v-if="storeDetail.tags.length && storeDetail.tags.length > 0">
				<span class="tag" v-for="tag in storeDetail.tags" :key="tag.id">{{tag.name}}</span>
			</li>
			<li class="font-s" v-show="storeDetail.class.class_type == 1 && storeDetail.class.shop_price && storeDetail.class.shop_price > 0 && storeDetail.class.group_price">
				<span class="pink-tag">拼团</span>拼团最多可省{{Math.round(((storeDetail.class.shop_price) - (storeDetail.class.group_price))*100)/100}}元
			</li>
			<li class="font-s" v-if="storeDetail.coupons && Number(storeDetail.coupons.face_value) > 0"><span class="primary-tag">券</span>学车立减{{Math.round(storeDetail.coupons.face_value)}}元</li>
		</ul>
	</div>
</template>

<script>
export default {
	name: 'school-item',
	props: {
		width: {
			type: String,
			default: '100px',
		},
		height: {
			type: String,
			default: '75px',
		},
		data: Object,
		storeDetail: Object,
	},
	methods: {
		handleClick() {
			// const id = 10;
			// if(this.$route.name === 'StDetail') {
			// 	// this.$emit('refresh', id)
			//
			// }else {
			// 	this.$router.push({ name: 'StDetail', query: { store_id: id } })
			// }
		},
	},
	created() {

	}
}
</script>

<style lang="less" scoped>
.school-item {
	box-sizing: border-box;
	width: 100%;
}
.pictrue {
	flex-shrink: 0;
	border-radius: 3px;
	margin-right: 10px;
}
ul {
	display: block;
	flex-grow: 1;
	width: 60%;
}
ul li {
	&:not(:last-child) {
		margin-bottom: 10px;
	}
}
.name {
	.text-ellipsis();
	display: block;
	//width: 80%;
	color: #333333;
	font-size: 17px;
	font-weight: bold;
	margin-right: 5px;
}
.address {
	.text-ellipsis();
	color: #999999;
	font-size: 13px;
}
.price {
	color: #666666;
	font-size: 13px;
}
.tag {
	.tag();
  border: 1px solid #cccccc;
	font-family: Microsoft YaHei;
}
.primary-tag {
	.tag(@bg:#6FCBF3, @color: #fff);
	min-width: 32px;
	text-align: center;
}
.pink-tag {
	.tag(@bg:#FF808E, @color: #fff);
	min-width: 32px;
	text-align: center;
}
.font-s {
	font-size: 12px;
	color: #333333;
}
.text-red {
	color: #eb273b;
	font-size: 14px;
	margin-left: 5px;
	padding-right: 10px;
}
</style>
